import React from "react";
import moment from "moment";
import "./Invoice.css";

export const InvoiceToPrint = React.forwardRef((props, ref) => {
  const { pageDetails } = props;

  if (!pageDetails) return null;

  const calculateGST = (total, customOrderWholesalePrice, totalTax) => {
    // Based on sample: Total 800, Tax 144 (18%)
    // Base Price 656

    const totalAmount =
      Number(total || customOrderWholesalePrice) + Number(totalTax);
    const cgst = totalTax ? totalTax / 2 : 0;
    const sgst = totalTax ? totalTax / 2 : 0;

    return {
      cgst: cgst.toFixed(2),
      sgst: sgst.toFixed(2),
      total: totalAmount.toFixed(2),
    };
  };

  const gstDetails = calculateGST(
    pageDetails.customOrderWholesalePrice
      ? Number(pageDetails.customOrderWholesalePrice) *
          Number(pageDetails.quantity)
      : Number(pageDetails.total || 0),
    pageDetails.gstOrderID,
    pageDetails.tax || 0,
  );

  // Simple number to words converter for the required range
  const numberToWords = (num) => {
    const a = [
      "",
      "one ",
      "two ",
      "three ",
      "four ",
      "five ",
      "six ",
      "seven ",
      "eight ",
      "nine ",
      "ten ",
      "eleven ",
      "twelve ",
      "thirteen ",
      "fourteen ",
      "fifteen ",
      "sixteen ",
      "seventeen ",
      "eighteen ",
      "nineteen ",
    ];
    const b = [
      "",
      "",
      "twenty",
      "thirty",
      "forty",
      "fifty",
      "sixty",
      "seventy",
      "eighty",
      "ninety",
    ];

    if ((num = num.toString()).length > 9) return "overflow";
    let n = ("000000000" + num)
      .substr(-9)
      .match(/^(\d{2})(\d{2})(\d{2})(\d{1})(\d{2})$/);
    if (!n) return "";
    let str = "";
    str +=
      n[1] != 0
        ? (a[Number(n[1])] || b[n[1][0]] + " " + a[n[1][1]]) + "crore "
        : "";
    str +=
      n[2] != 0
        ? (a[Number(n[2])] || b[n[2][0]] + " " + a[n[2][1]]) + "lakh "
        : "";
    str +=
      n[3] != 0
        ? (a[Number(n[3])] || b[n[3][0]] + " " + a[n[3][1]]) + "thousand "
        : "";
    str +=
      n[4] != 0
        ? (a[Number(n[4])] || b[n[4][0]] + " " + a[n[4][1]]) + "hundred "
        : "";
    str +=
      n[5] != 0
        ? (str != "" ? "and " : "") +
          (a[Number(n[5])] || b[n[5][0]] + " " + a[n[5][1]])
        : "";
    return str.trim() + " rupees";
  };

  return (
    <div
      className="invoice-print-wrapper"
      style={{ position: "absolute", left: "-9999px", top: "-9999px" }}
    >
      <div ref={ref} className="invoice-container">
        <div className="invoice-header">
          <div className="invoice-logo-left">
            <img src="/logo.png" alt="TCT Logo" />
          </div>
          <div className="invoice-logo-center">
            <img src="/mani_logo.png" alt="Mani Gift Manufacturer Logo" />
          </div>
          <div className="invoice-title-info">
            <h2>Original For recipient</h2>
            <p>
              Invoice No:{" "}
              <span className="text-red">
                {pageDetails.gstOrderID || pageDetails.orderId}
              </span>
            </p>
            <p>
              Date :{" "}
              <span className="text-red">
                {moment(pageDetails.createdAt).format("DD-MM-YYYY")}
              </span>
            </p>
          </div>
        </div>

        <div className="invoice-details-row">
          <div className="org-info">
            <h3>
              Organisation Name:
              <span className="text-red">The charming treasure</span>
            </h3>
            <p>
              GSTIN :<span className="text-red">33DQHPM7326H1ZQ</span>
            </p>
            <p>12,13,south masi street,</p>
            <p>Madurai-625001</p>
            <p>Mobile:9361299361/9994479044</p>
            <p>Mail id:thecharmingtreasure1093@gmail.com</p>
          </div>
          <div className="customer-info">
            <h3 className="text-red">To:</h3>
            <p>Customer name: {pageDetails.address?.name}</p>
            <p>
              Address: {pageDetails.address?.address},{" "}
              {pageDetails.address?.city}
            </p>
            <p>Pincode: {pageDetails.address?.zip}</p>
            <p>Mobile number: {pageDetails.address?.phone}</p>
            <p>Mail id: {pageDetails.address?.email || ""}</p>
            <p>Gst number: {pageDetails.address?.gstNo || ""}</p>
          </div>
        </div>

        <div className="table-wrapper">
          <table className="invoice-table">
            <thead>
              <tr>
                <th>S.No</th>
                <th>Product name</th>
                <th>HSN/SAC</th>
                <th>Size</th>
                <th>Price</th>
                <th>Quantity</th>
                <th>CGST</th>
                <th>SGST</th>
                <th>Total</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>1</td>
                <td className="product-name">
                  {pageDetails?.BillingProductDetail?.BillingProduct?.name ||
                    pageDetails.customOrderProductName ||
                    pageDetails.Category?.name}
                </td>
                <td>
                  {pageDetails.BillingProductDetail?.BillingProduct?.hsnCode ||
                    "39269099"}
                </td>
                <td>{pageDetails.attributesDetails?.[0]?.name || "-"}</td>
                <td>
                  {pageDetails.customOrderWholesalePrice
                    ? pageDetails.customOrderWholesalePrice
                    : pageDetails.price}
                </td>
                <td>{pageDetails.quantity || 1}</td>
                <td>{gstDetails.cgst}</td>
                <td>{gstDetails.sgst}</td>
                <td>{gstDetails.total}</td>
              </tr>
              {pageDetails.deliveryCharge > 0 && (
                <tr>
                  <td>2</td>
                  <td className="product-name">Courier charges</td>
                  <td>996511</td>
                  <td>-</td>
                  <td>{(pageDetails.deliveryCharge / 1.18).toFixed(2)}</td>
                  <td>1</td>
                  <td>{(pageDetails.deliveryCharge * 0.09).toFixed(2)}</td>
                  <td>{(pageDetails.deliveryCharge * 0.09).toFixed(2)}</td>
                  <td>{pageDetails.deliveryCharge}</td>
                </tr>
              )}
            </tbody>
          </table>
        </div>

        <div className="total-row-container">
          <div className="total-label">Total:</div>
          <div className="total-amount">
            {Number(
              Number(gstDetails.total) +
                Number(pageDetails.deliveryCharge || 0),
            ).toFixed(2)}
          </div>
        </div>

        <div className="amount-words">
          Amount in words:
          <span className="text-red" style={{ textTransform: "capitalize" }}>
            {" "}
            {numberToWords(
              Math.round(
                Number(gstDetails.total) +
                  Number(pageDetails.deliveryCharge || 0),
              ),
            )}
          </span>
        </div>

        <div className="bank-tnc-row">
          <div className="bank-info">
            <h4 className="text-red">Fund transfer information</h4>
            <p>Bank name : State bank of india</p>
            <p>Account holder name : The charming treasure</p>
            <p>Account number : 44479196193</p>
            <p>IFSC code : SBIN0010315</p>

            <h4 className="text-red" style={{ marginTop: "10px" }}>
              Terms & Conditions
            </h4>
            <div
              className="tnc-text-container"
              style={{ fontSize: "10px", lineHeight: "1.2" }}
            >
              1. We make every effort to display product colors accurately on
              our website.
              <br />
              <b>
                However, actual colors may vary depending on your device or
                monitor settings,
              </b>
              <br />
              and we cannot guarantee exact color accuracy.
              <br />
              2.We reserves the right to refuse or cancel any order placed for
              products listed at incorrect prices or for any other reason.
              <br />
              If payment has already been made, the amount will be refunded and
              the user will be informed accordingly.
              <br />
              3.In cases of non-delivery or delayed delivery caused by incorrect
              or incomplete information provided by the user
              <br />
              (such as wrong address or recipient unavailability), any
              additional re-delivery cost shall be borne by the user
              <br />
              4.We shall not be responsible for any damages suffered by users
              due to the use of our services.
              <br />
              This includes, but is not limited to, loss of revenue, data loss,
              delays, missed or failed deliveries,
              <br />
              or service interruptions caused by vendor-related issues.
              <br />
              5.<b>Product Making time 2days,Delivery within 4working days</b>
              <br />
              6.If professional courier office near by your address,They will
              come,Sometimes customer will collect near by professional courier
              <br />
              7.Customer should take a video of parcel opening video for damaged
              product given by courier ,Video must need for replacement
            </div>
          </div>
          <div className="signatory-section">
            <h4 className="text-red">AUTHORISED SIGNATORY</h4>
            <div className="stamp-area">
              <img src="/signature.png" alt="Seal" className="seal-img" />
              <div className="signatory-name">MANIKANDAN</div>
              <div className="signatory-title">
                Proprietor of The charming treasure
              </div>
            </div>
          </div>
        </div>

        <div className="footer-note">
          * Note: This is a system generated invoice
        </div>
      </div>
    </div>
  );
});
